// extracted by mini-css-extract-plugin
export default {"tabs":"GolfClubAvailability_tabs__aS3GS","tab":"GolfClubAvailability_tab__G7zjp","active":"GolfClubAvailability_active__qH-Hu"};